export enum ApiMask {
  GameSocket = 0b00000001,
  CasinoConfig = 0b00000010,
  EnvConfig = 0b00000100,
  PlayerConfig = 0b00001000,
  TableConfig = 0b00010000,
  Version = 0b00100000,
  Balance = 0b01000000,
  StatsSettings = 0b10000000,
}

export const updateApiMask = (bit: ApiMask): void => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  window.loadingStateMask |= bit;
};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
window.loadingStateMask = 0;
